import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-functional-overhead-categories',
  templateUrl: './functional-overhead-categories.component.html',
  styleUrls: ['./functional-overhead-categories.component.scss']
})
export class FunctionalOverheadCategoriesComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.FunctionalOverheadCategories.columns;
    this.data = this.report.FunctionalOverheadCategories.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.FunctionalOverheadCategories.data;
    const gridInstance = this.gridContext.getInstance('FunctionalOverheadCategories');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/functional-overhead-categories/functional-overhead-categories.component.ts